import * as React from 'react';
import { Spin, Menu, Card, Row, Col, Input, Button, Breadcrumb, Modal, message, Dropdown, Icon } from 'antd';
import { IcommonProps } from '../common/props';
import moment from 'moment';
import Constants from '../common/constants';
import TestList from '../test/TestList';
import '../../css/ViewProfile.scss';
import Print from '../common/print';
import Export from '../common/export';
import Util from '../common/utils';
import ShareTests from '../test/ShareTest';
import { STATICKEYS, staticProperties } from '../common/staticProperties';
import { MSGDISPLAYTIME } from '../common/constants';
import service from '../../service/apolloclient.service';
import { Link } from 'react-router-dom';
import { VIEWSTATE } from '../common/constants';
import Auth from '../common/auth';
import { Tasks } from '../common/auth';
import { BASELINETYPE } from '../common/constants';
import Token from '../common/token';
// import UserIcon from '../../images/illustrationprofile.svg';
import strings from '../../eyeguide-localization/profile/strings.profile.view';
import TestPdf from '../test/testPdf';
import * as jsPDF from 'jspdf';
import TestDonwloadHelper from '../common/testDownloadHelper';
const testDownloader = new TestDonwloadHelper();
const userIcon = require('../../images/illustration-profile.png');
// class UserIcon extends React.Component {
//     render() {
//         return (
//             <img src={userIcon} />
//         );
//     }
// }

/**
 * Property definition 
 */
interface IViewProfileProps extends IcommonProps {
    match: any;
    location: any;
}

/**
 * State definition
 */
interface IViewProfileState {
    sportsArr: string;
    levelVal: any;
    gender: any;
    sharetests: any;
    exportModalVisisble: boolean;
    shareModalVisible: boolean;
    shareUsers: any;
    profile: any;
    firstname: string;
    lastname: string;
    loading: boolean;
    emptyText: string;
    canEditProfile: boolean;
    showEditAction: boolean;
    showHealthData: boolean;
    organization: any;
    testExporting: boolean;
    testExportingTip: string;
}

export default class ProfileView extends React.Component<IViewProfileProps, IViewProfileState> {
    firstname:      React.RefObject<Input> ;
    lastname:       React.RefObject<Input> ;
    birthdate:      React.RefObject<any> ;
    id:             React.RefObject<Input> ;
    gender:         React.RefObject<Input> ;
    level:          React.RefObject<Input> ;
    sport:          any ;
    email:          React.RefObject<Input> ;
    phone:          React.RefObject<Input> ;
    notifyEmail:    React.RefObject<Input> ;
    notifyPhone:    React.RefObject<Input> ;
    organization:   React.RefObject<Input> ;
    metaInfoMap: any;
    iframe: HTMLIFrameElement | null;

    menu = (
        <Menu 
                onClick={(event) => {
                            switch (event.key) {
                                case '2': this.exportFile(); break;
                                case '1': this.exportTestRecord(); break;
                                default: break;
                            }
                        }}
        >
          <Menu.Item key="1">Test</Menu.Item>
          <Menu.Item key="2">CSV</Menu.Item>
        </Menu>
    );

    constructor(props: IViewProfileProps) {
        super(props); 
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.firstname = React.createRef();
        this.lastname = React.createRef();
        this.birthdate = React.createRef();
        this.id = React.createRef();
        this.sport = '';
        this.level = React.createRef();
        this.organization = React.createRef();
        this.email = React.createRef();
        this.phone  = React.createRef();
        this.notifyEmail = React.createRef();
        this.notifyPhone = React.createRef();
        this.gender = React.createRef();
        this.state = {
            sportsArr: '',
            levelVal: '',
            gender: '',
            sharetests: [],
            exportModalVisisble: false,
            shareModalVisible: false,
            shareUsers: [],
            profile: [],
            firstname: '',
            lastname: '',
            loading: true,
            emptyText: '',
            canEditProfile: Auth.canPerformTask(roleid, Tasks.canEditProfile),
            showEditAction: Auth.canPerformTask(roleid, Tasks.canEditTest),
            showHealthData: Auth.canPerformTask(roleid, Tasks.canViewHealthData),
            organization: {},
            testExporting: false,
            testExportingTip: ''
        };  
        this.setShareTests = this.setShareTests.bind(this);      
        this.setShareModalVisible = this.setShareModalVisible.bind(this);
        this.shareTestClick = this.shareTestClick.bind(this);
        this.shareTests = this.shareTests.bind(this);
        this.testUpdate = this.testUpdate.bind(this);

    }

    async componentDidMount() {
        Util.resetScroll();
        // let sportArr = this.getValuesSepByComma(this.getInputValue('sport', ''));
        // if (sportArr.length === 0 || sportArr[0] === '' ) { 
        //     sportArr = [];
        // }
        let profile: any = await this.getProfile(this.props.match.params.playerid);
        var organization: any = await new service().getOrganizationByRoster(profile.rosterid);
        this.setState({profile: profile}); 
        staticProperties.set(STATICKEYS.selectedKey, profile.rosterid + VIEWSTATE.ROSTER);
        console.log('rosterid', profile.rosterid);
        staticProperties.set(STATICKEYS.selectedRoster, profile.rosterid);
        this.setState({
            sportsArr: this.getCommaStringWithSpace(this.getInputValue('sport', '')),
            levelVal : this.getInputValue('level', ''),
            gender: this.getInputValue('gender', ''),
            profile: profile,
            loading: false,
            emptyText: profile !== undefined && profile.tests.length === 0 ? 'No data' : '',
            organization
        });
    }

    setShareTests(testlist: Array<any>) {
        this.setState({
            sharetests: testlist
        });
    }

    render() { 
        if ( this.state.loading ) {
            return (
                <div>
                    Loading...
                </div>
            );
        }
        // console.log('render view', this.state.profile.rosterid);
        let middlename = this.getInputValue('middlename', '') + ' ';
        let profileName = (this.state.profile.firstname + ' ') + (middlename) +
                     this.state.profile.lastname;

        return (
            <div className="ViewProfile">
            <Spin spinning={this.state.testExporting} tip={this.state.testExportingTip}>
            <Card className="cardFont">
            <Breadcrumb>
                <Breadcrumb.Item ><a href="/dashboard">{'Home'}</a></Breadcrumb.Item>
                <Breadcrumb.Item ><a href={'/profile/' + this.state.profile.rosterid}>
                {this.state.profile.organizationname + ' ' + strings.lsProfilesTxt}</a></Breadcrumb.Item>
                <Breadcrumb.Item >{this.state.profile.firstname + ' ' + 
                                    this.state.profile.lastname}</Breadcrumb.Item>
            </Breadcrumb>
            <br/>
            <Row>
            <Col xs={2} sm={12} md={12} lg={2} xl={2}>
                {/* <Icon type="user" style={{ fontSize: 42}} /> */}
                {/* <Avatar  size="large" src={userIcon}/> */}
                <img src={userIcon} />
                
            </Col>
            <Col xs={8} sm={12} md={12} lg={8} xl={8}>
                <h2>{profileName} </h2>
            </Col>
            <Col xs={14} sm={12} md={12} lg={14} xl={14}>
            <div className="label">
                {/* <Button 
                    className="backBtn" 
                    onClick={e => {
                            history.back();
                    }}
                >
                    Back
                </Button> */}
                {this.state.canEditProfile ? 
                <Link
                    style={{color: 'white'}}
                    to={'/profile/edit/' + this.props.match.params.playerid}
                >
                    <Button 
                        type="primary" 
                    >
                    {strings.lsEditTxt}
                    </Button>
                </Link>
                : '' }
                </div>
            </Col>
            </Row>
            <Row>
                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
            <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="clipped leftSpacing">
                <span className="infoLabels">  {strings.lsIDTxt}: </span> 
                <span 
                    className="viewProfileVals" 
                    title={this.getInputValue('profileID', '')}
                > {this.getInputValue('profileID', '')} 
                </span>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div>
                <span className="infoLabels">  {strings.lsSportTxt}: </span> 
                <span className="viewProfileVals">  {this.state.sportsArr} </span>
            </div>
            </Col>
            </Row>
            <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="leftSpacing">
                            <span 
                                className="infoLabels"
                            > {strings.lsBDayTxt}: 
                            </span> 
                            <span className="viewProfileVals"> 
                                {this.formatDate('birthdate', '')} 
                            </span>
            </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <span className="infoLabels">  {strings.lsLevelTxt}: </span> 
                <span className="viewProfileVals">  {this.state.levelVal} </span>
            </Col>
            </Row>
            <Row className="viewRow">
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="leftSpacing">
                            <span 
                                className="infoLabels"
                            > {strings.lsGenderTxt}: 
                            </span> 
                            <span 
                                className="viewProfileVals"
                            >  
                                {this.getName(this.getInputValue('gender', ''), Constants.getGender())} 
                            </span>
            </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <span className="infoLabels">  {strings.lsOrgTxt}: </span > 
                <span className="viewProfileVals"> {this.state.profile.organizationname} </span>
            </Col>
            </Row>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12} className="alignRight">
                        <Row>
                            <span>  {strings.lsBaselineTxt} </span> 
                        </Row>
                        <Row>
                            <span 
                                className="infoLabels infoHighlight"
                            > 
                                {this.state.profile.baseline} 
                            </span>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12} className="alignRight">
                        <Row>
                            <span>  {strings.lsTotalTestTxt} </span> 
                        </Row>
                        <Row>
                            <span 
                                className="infoLabels infoHighlight"
                            >  
                                {this.state.profile.tests !== undefined ? this.state.profile.tests.length : 0} 
                            </span> 
                        </Row>
                    </Col>
                </Col>
            </Row>
        </Card>
            <div >
            <Card 
                className="cardFont" 
                title={strings.lsContactInfoTxt} 
                bordered={false} 
                style={{ margin: '24px 16px' }} 
            >
                <Row className="row">
                    <Col xs={12} sm={12} md={12} lg={12} xl={9}>
                        <Row>
                            <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                                <div className="infoLabels">{strings.lsEmailTxt}:</div>
                            </Col>
                            <Col  xs={9} sm={9} md={9} lg={9} xl={19}>
                                <div className="hyphenate"> {this.getInputValue('email', '')}  </div>
                            </Col>
                        </Row>
                        <Row className="rowSpace">
                            <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                                <div className="infoLabels">{strings.lsPhoneTxt}:</div>
                            </Col>
                            <Col  xs={9} sm={9} md={9} lg={9} xl={19}>
                                <span className="hyphenate"> {this.getInputValue('phone', '')}  </span>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Row>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                <div className="infoLabels">{strings.lsNotifyEmailTxt}:</div>
                            </Col>
                            <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                <span className="hyphenate"> {this.getInputValue('notifyEmail', '')}  </span>
                            </Col>
                        </Row>
                        <Row className="rowSpace">
                            <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                <div className="infoLabels">{strings.lsNotifyPhonesTxt}:</div>
                            </Col>
                            <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                <span className="hyphenate"> {this.getInputValue('notifyPhone', '')}  </span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
                <Card className="cardFont" title={strings.lsTestHistoryTxt} style={{ margin: '24px 16px' }}>
                    <Button 
                        icon="right" 
                        type="primary" 
                        style={{marginBottom: 20 }} 
                        disabled={this.state.sharetests.length === 0}
                        onClick={e => this.shareTestClick()}
                    > {strings.lsShareTextTxt}
                    </Button>
                    <Button 
                        style={{marginLeft: 10, marginBottom: 20 }}
                        onClick={() => this.printList()}
                        disabled={this.state.sharetests.length === 0}
                    >{strings.lsPrintTxt}
                    </Button>  
                    <iframe 
                        style={{height: 0, width: 0, border: 'none'}} 
                        ref={el => this.iframe = el} 
                    />  

                    <Dropdown 
                        trigger={['click']}
                        overlay={this.menu}
                        getPopupContainer={this.getContainer}
                        disabled={this.state.sharetests.length === 0}
                    >
                        <Button 
                            style={{marginLeft: 10, marginBottom: 20 }}
                            disabled={this.state.sharetests.length === 0}
                        > 
                            {strings.lsDownloadTxt} <Icon type="down" style={{ fontSize: 15}}/> 
                        </Button>
                    </Dropdown>
                    <Modal
                        title={strings.lsExportProfileTxt}
                        visible={this.state.exportModalVisisble}
                        onOk={() => this.setState({exportModalVisisble: false})}
                        okText={strings.lsOkTxt}
                        width={350}
                        bodyStyle={{padding: 0 }}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button 
                                    key="Ok" 
                                    type="primary"  
                                    onClick={() => this.setState({exportModalVisisble: false})}
                            >
                            {strings.lsOkTxt}
                            </Button>,
                        ]}
                    >
                        <Row style={{padding: '19px'}}>
                        {strings.lsTestExportSuccessTxt}
                        </Row>
                    </Modal>
                    <Modal
                        className="modal"
                        title={strings.lsShareTextTxt}
                        visible={this.state.shareModalVisible}
                        okText={strings.lsShareTxt}
                        onOk={() => this.setShareModalVisible(1)}
                        onCancel={() => this.setShareModalVisible(0)}
                        width={800}
                        maskClosable={false}
                        closable={false}
                    >
                        <ShareTests
                            sharedTests={this.state.sharetests}
                            notifyUsers={this.shareTests}
                            isOpen={this.state.shareModalVisible}
                        />
                    </Modal>
                    <TestList 
                        organizationID={this.props.organizationID} 
                        testtags={this.state.organization.testtags}
                        rosterID={this.props.rosterID} 
                        tests={this.state.profile.tests !== undefined ? this.state.profile.tests.length > 0 ?
                                        this.state.profile.tests : [] : []}
                        notifySelectedTests={this.setShareTests}
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        pagination={false}
                        sorting={true}
                        showAthelete={false}
                        showDownloadAction={false}
                        loading={this.state.loading}
                        emptyText={this.state.emptyText}
                        showEditAction={this.state.showEditAction}
                        notifyTestUpdated={this.testUpdate}
                    />
                </Card>
            </div>
            </Spin>
            </div>
        );
    }

    /**
     * Returns value of the property
     * @param property attribute name to extract value from props.profile
     * @param defaultVal default value, if attribute not found
     */
    private getInputValue(property: string, defaultVal: string): string {
        let metaInfoMap = this.metaInfoMap;
        let defaultValue: string = '';
        let playerinfo = this.state.profile !== '' &&  (this.state.profile !== undefined && 
            this.state.profile.playerinfo !== undefined)
                    ? this.state.profile.playerinfo.filter((e: any) => 
                                e.playerinfoname === property) : '';
        if (playerinfo.length === 0) {
            // defaultValue = this.getDisbledColumnVal(property, this.metaInfoMap);
            if (metaInfoMap !== '' && metaInfoMap !== undefined && metaInfoMap.length > 0) {
                let metaInfo: any = metaInfoMap.filter( (x: any) => 
                    x.metainfoname === property
                );
                if (metaInfo.length > 0) {
                    defaultValue = metaInfo[0].metainfovalue;
                }
            }
        }
        return playerinfo.length !== 0 ? playerinfo[0].playerinfovalue : defaultValue;
    }

    /**
     * Returns date from miliseconds.
     * @param attr date attribute whose value needs to be fetched for formatting
     * @param defaultVal default value to be set if no value provided
     */
    private formatDate(attr: string, defaultVal: string): any {
        console.log('formatdate');
        let dobInMS = this.getInputValue(attr, defaultVal);
        console.log('dobinMS', dobInMS);
        let dateVal: any = '';
        if (dobInMS !== '') {
            dateVal = moment(parseInt(dobInMS, 10));
            return moment(dateVal).format('MMMM DD[,] YYYY'); 
        }
    }

    /**
     * Returns array of values obtained by splitting on ','
     * @param commaSepList String containing comma seperated list
     */
    private getCommaStringWithSpace(commaSepList: string) {
        let values: any = commaSepList !== null ? commaSepList.split(',') : [];
        let commaSepString: string = '';
        if (values.length > 0) {
            for (let i = 0; i < values.length; i++) {
                if (i === values.length - 1) {
                    commaSepString += values[i]; 
                } else {
                    commaSepString += values[i] + ', '; 
                }
            }
            return commaSepString;
        } else {
            return commaSepList;
        }
    }

    private getName(value: any, list: any) {
        return list[value];
    }

    private printList() {
        console.log('profilesFromPrint', this.state.profile.tests);
        let buildData: any;
        buildData = this.buildTestData(this.state.profile.tests, this.state.sharetests);
        if (buildData.length > 0) {
            Print.printContents(buildData, 'Tests', this.iframe);
        }
    }

    private exportFile() {
        console.log('profilesFromPrint', this.state.profile.tests);
        let buildData: any;
        buildData = this.buildTestData(this.state.profile.tests, this.state.sharetests);
        if (buildData.length > 0) {
            Export.exportCSVFile(buildData, 'tests');
            this.setState({exportModalVisisble: true});
        }
    }

    /**
     * export the current test records
     */
    private exportTestRecord() {
        let canvas = [];
        let doc = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'letter',
        });
        let ser = new service();
        this.setState({testExporting: true, testExportingTip: 'Exporting 0 of ' + this.state.sharetests.length });
        this.state.sharetests.reduce(
            (prev, testid, i) => {
                return prev.then(async () => {
                    this.setState({
                                    testExporting: true, 
                                    testExportingTip: 'Exporting ' + i + ' of '  + this.state.sharetests.length });
                    let testResult = await ser.getTestResults(testid, 0);
                    let testHistory = await ser.getTestsAfterLastBaseline(
                        testResult[0].playerid, testResult[0].testtimestamp
                    );
                    return TestPdf({
                        index: i,
                        state: {testResult: testResult[0], testHistory},
                        doc: doc,
                        isLast: i === this.state.sharetests.length - 1,
                        setCanvas: () => testDownloader.downloadTest(testResult[0], i, canvas, ser),
                        notifyDownload: () => this.setState({
                                                            exportModalVisisble: true, 
                                                            testExporting: false, 
                                                            testExportingTip: ''})
                    });
                });
            },
            Promise.resolve()
        );
    }

    private buildTestData(tests: Array<any>, selectedTest: Array<any> | undefined = undefined) {
        let columnData: Array<any> = [];
        tests.forEach( (element: any) => {
            if ( selectedTest !== undefined && 
                selectedTest.findIndex( testid => testid === element.testid ) === -1 ) {
                return;
            }
            let data: any = {};
            if (this.state.showHealthData) {
                data = {
                name: element.athlete.firstname + ' ' + element.athlete.lastname,
                date_and_time: Util.getDate(element.testtimestamp) + ' ' + Util.getTime(element.testtimestamp),
                test_type: element.testtag,
                score_type: element.baseline === 1 ? strings.lsBaselineTxt :  
                            Util.getLocalizedTestType(element.range) ,
                    // dr_dx_concussion: Util.getConcussed(element.concussed),
                score: Util.formatNumber(element.score, 2),
                eye: element.testinfo.length ? 'Left' : 'Right'
            };
            }  else {
                data = {
                    name: element.athlete.firstname + ' ' + element.athlete.lastname,
                    date_and_time: Util.getDate(element.testtimestamp) + ' ' + Util.getTime(element.testtimestamp),
                    test_type: element.testtag,
                    score_type: element.baseline === 1 ? BASELINETYPE.BASELINE : BASELINETYPE.TEST,
                };
            }
            columnData.push(data);
        }); 
        return columnData;
    }

    private async setShareModalVisible(event: number) {
        if (event === 1) { // share
            let testids = this.state.sharetests;
            let input: any = [];
            console.log('modalVisible share users', this.state.shareUsers);
            if (this.state.shareUsers.length > 0) {
                this.state.shareUsers.forEach((element: any) => {
                    input.push({firstname: element.fname, lastname: element.lname,
                        email: element.email, phone: element.phone});
                });
                console.log('input to create', input);
                console.log('testids to create', testids);
                staticProperties.set(STATICKEYS.clearSelection, true);
                this.setState({ sharetests: [], shareUsers: [] });
                let ser = new service();
                let response = await ser.createSharedTest(testids, 0, input);
                console.log('create response', response);
                if (response.status === 0) {
                    message.success(strings.lsTestSharedSuccessTxt, MSGDISPLAYTIME);
                } else {
                    message.error(strings.lsTestShareFailTxt, MSGDISPLAYTIME);
                }
            } else {
                return;
            }
        }
        this.setState({
            shareModalVisible: false
        });
        console.log('number');
    }

    private shareTestClick() {
        this.setState({
            shareModalVisible: true
        });
    }

    private shareTests(shareUsers: any) {
        this.setState({
            shareUsers
        });
        console.log('shareTests', shareUsers);
    }

    private async getProfile(playerid: any) {
        let ser = new service(); 
        let profile = await ser.getProfile(playerid);
        console.log('getProfile', profile);
        return profile[0];
    }

    private async testUpdate() {
        let profile: any = await this.getProfile(this.props.match.params.playerid);
        this.setState({profile: profile});
    }

    /**
     * Attatches dropdown lists to parent containers to avoid displacement during scroll
     */
    private getContainer = (triggernode) => {
        // debugger;
        return triggernode.parentNode;
    }

}


// WEBPACK FOOTER //
// ./src/components/profile/ViewProfile.tsx